import type { FaireProductEntity } from "../../entity_types/product";

export const p_gdk644d9mm: FaireProductEntity = {
  token: "p_gdk644d9mm",
  type: "product",
  name: "IT2638-SET | Solid Cotton Camisole & Wide-Leg Pant Set",
  brandToken: "b_4o95d3k7hq",
  brandName: "BUCKETLIST INC",
  imageUrl:
    "https://cdn.faire.com/fastly/70c659a13f6c495fcfc44fbd4cd5d107f4b14ad8c4fce7f36eba5beec0639bb3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5650b548e36ba97347fa62a7ce35667b65aa8aa3a394c16f07348fd40eae1967.jpeg",
    "https://cdn.faire.com/fastly/986b4c6f169438af818838c0a9a448abfca3b68d41e6add1670ad089e91539d5.jpeg",
    "https://cdn.faire.com/fastly/5c08f11d8ca712119db9db52100b83e11bcca8260f827b06356e6484c957bd04.jpeg",
    "https://cdn.faire.com/fastly/7200b9a2538b2ee18656040c1635f3041e7195a7afca3bc785a98c5109e403bf.jpeg",
    "https://cdn.faire.com/fastly/7a8388ed74f0291c67daade551c6830dd6e7940d3c150ad23bfac7aaf2d59f01.jpeg",
    "https://cdn.faire.com/fastly/729e89e911b9bb738f619b67720be9bab3141a0018e5b2686c79f141450f044f.jpeg",
    "https://cdn.faire.com/fastly/f128f57b2b65775387ad9fb021ffc170ce89966c03ebf9cc92359eb7b5186590.jpeg",
    "https://cdn.faire.com/fastly/c4db30bd5cb183ecd0fc3bd9ee79a5535a77a8e49f62516d2ea04173755038d4.jpeg",
    "https://cdn.faire.com/fastly/d2ee44f7f31eb2da39393ed909a6b9cb584f8794ca85f24cccdeaca6716cff45.jpeg",
    "https://cdn.faire.com/fastly/de397d42eeec96be6ecf7b7f502730b22bde74a8f1c32d6e7792049f6858d0f9.jpeg",
    "https://cdn.faire.com/fastly/f784dfa6ffb58440f529382c71b1345128da5d6133cc95792047baa1e04f1e20.jpeg",
    "https://cdn.faire.com/fastly/5febcd5ac36257618a052f9204104a2dabaa1251ec755affd99497f00c0fb150.jpeg",
    "https://cdn.faire.com/fastly/7f74c63ba38952eb6da6c0e82a89306fc3030a8e601c8a993ebda936c4f0c47a.jpeg",
    "https://cdn.faire.com/fastly/62c62b1c3cba0112393d066bed1377f3ca6c3cd703c263a624ce9b389b4beeb7.jpeg",
    "https://cdn.faire.com/fastly/6feb2d02fe3c7a8c1481d1545b54d9edc090d9484d4caaf373c7df1b0c335f39.jpeg",
    "https://cdn.faire.com/fastly/2c31d58bf57a94b2da97f8469dd08d7f239e6ac45838e308821cc11b63f8baff.jpeg",
    "https://cdn.faire.com/fastly/ef0fb15983025df2d4511b6de3f012c7339b47b17b53579c46d783c7e0730888.jpeg",
  ],
  priceDollars: 28.95,
  description:
    "Solid Cotton Camisole & Wide-Leg Pant Set\n- A lightweight cotton set featuring a relaxed camisole top paired with easy, wide-leg pants for effortless warm-weather styling.\n- The top is designed with a soft gathered neckline, adjustable shoulder straps, and a naturally draping silhouette.\n- The matching pants feature a relaxed straight fit, elastic drawstring waist, and clean side detailing for a sporty touch.\n- Wear the pieces together as a coordinated set or mix them effortlessly into everyday looks.\n\nFabric & Fit\n- 100% Cotton for breathable comfort and a soft, lightweight feel.\n- Relaxed, easy fit that drapes naturally with comfortable movement.\n\nA breezy, lightweight cotton set that combines easy comfort with relaxed styling.",
  tags: [],
  msrpDollars: 57.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:50.355Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
